<template>
  <div class="rightContent">
    <div class="header">
      <h1>{{ $t('integration.detection_equipment_monitoring') }}</h1>
      <div>
        <i
          v-for="item in iconArray"
          :key="item.id"
          :title="item.title"
          :class="item.icon"
          @click="handleClick(item)"
        ></i>
      </div>
    </div>
    <!-- 右侧设备信息框 -->
    <el-empty
      v-if="newArray.length === 0"
      :description="$t('integration.please_view_first')"
    ></el-empty>
    <div v-else class="rightMsg">
      <Msg
        v-for="item in newArray"
        :key="item.id"
        :infoObj="item"
        :iconDetaiArray="changeIcon(item)"
      >
        <!-- 传感器关联网关 -->
        <template v-slot:sensor-w v-if="item.deviceCatalog == 0">
          <li :title="$t('integration.gateway')">
            <span>{{ item.param.gatewayName }}</span>
            <i
              class="el-icon-tickets"
              :title="$t('integration.gateway_details')"
              @click="handleGateway(item)"
            ></i>
          </li>
        </template>
        <!-- 网关的mac -->
        <template v-slot:gateway-mac v-if="item.deviceCatalog == 1">
          <li :title="$t('integration.mac_address')">
            <span>{{ item.param.mac }}</span>
          </li>
        </template>
        <!-- 显示屏的时区 -->
        <template v-slot:dispaly-timeZone v-if="item.deviceCatalog == 2">
          <li :title="$t('integration.time_zone')">
            <span>{{ timeCode(item.param.timeCode) }}</span>
          </li>
        </template>
      </Msg>
    </div>
    <!-- <gatewayDetailDialog :show.sync="gatewayDetailShow"></gatewayDetailDialog> -->
  </div>
</template>

<script>
import bus from '@/utils/bus.js'
import Msg from './rightMsg/Msg.vue'
import { goNewWindows } from '@/utils/goNewWin.js'
import {
  displayscreenTypeConvert,
  equiStatusConvert,
  gatewayTypeConvert,
  relayTypeConvert
} from '@/utils/convert'
import { shareParam } from '@/api/modules/public.js'
import { monitorAdd } from '@/api/modules/dataBoard.js'
import gatewayDetailDialog from '@/components/dialog/gatewayDetail/gatewayDetailDialog.vue'
import { sensorTypeConvert } from '@/utils/dict/sensor'

export default {
  props: {
    rightArray: {
      type: Array,
      default: () => []
    },
    getCheckArray: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  watch: {
    rightArray (newVal) {
      this.newArray = [...newVal]
      // 这里需要存储一波在本地  供给win弹窗使用
      sessionStorage.setItem('newArray', JSON.stringify(this.newArray))
      bus.$emit('selectListChange', this.newArray)
    }
  },
  components: {
    Msg,
    // gatewayDialog
    gatewayDetailDialog
  },
  data () {
    return {
      sensorTypeConvert,
      equiStatusConvert,
      gatewayDetailShow: false,
      iconArray: [
        {
          icon: 'el-icon-copy-document',
          title: $t('integration.pop_up_button'),
          id: 1
        },
        {
          icon: 'el-icon-refresh',
          title: $t('public.reflash'),
          id: 2
        },
        {
          icon: 'iconfont icon-baocun',
          title: $t('public.save'),
          id: 3
        }
      ],
      deviceArray: [],
      iconDetaiArray: [],
      // 时区
      timeCodeArray: [],
      // 右侧内容
      newArray: []
    }
  },
  created () {
    this.getTimeCodeFn()
  },
  mounted () {
    bus.$on('cancelCheck', id => {
      this.newArray = this.newArray.filter(item => id !== item.param.id)
    })
  },
  methods: {
    getTimeCodeFn () {
      shareParam({
        code: 'ADMIN_CONFIG_LABEL_NOTICE_ZONE',
        type: 0
      }).then(({ result }) => {
        this.timeCodeArray = result
      })
    },
    timeCode (code) {
      let str
      for (const item of this.timeCodeArray) {
        if (item.code === code) {
          str = item.name
          break
        }
      }
      return str
    },
    changeIcon (item) {
      const array = [
        {
          id: 4,
          icon: 'el-icon-tickets',
          title: $t('integration.equipment_details')
        }
      ]
      switch (String(item.deviceCatalog)) {
        case '0': {
          return (this.iconDetaiArray = [
            {
              id: 1,
              icon: sensorTypeConvert(item.param.type).icon,
              title: this.$t(sensorTypeConvert(item.param.type).title)
            },
            {
              id: 2,
              icon: equiStatusConvert(item.param.status).icon,
              title: this.$t(equiStatusConvert(item.param.status).title)
            },
            {
              id: 3,
              icon: 'el-icon-data-line',
              title: $t('integration.historical_line_chart')
            }
          ].concat(array))
        }
        case '1': {
          return (this.iconDetaiArray = [
            {
              id: 1,
              icon: gatewayTypeConvert(item.param.type).icon,
              title: this.$t(gatewayTypeConvert(item.param.type).title)
            },
            {
              id: 2,
              icon: equiStatusConvert(item.param.status).icon,
              title: this.$t(equiStatusConvert(item.param.status).title)
            },
            {
              id: 3,
              icon: 'iconfont icon-xintiao',
              title: $t('integration.whether_to_start_heartbeat')
            }
          ].concat(array))
        }
        case '2': {
          return (this.iconDetaiArray = [
            {
              id: 1,
              icon: displayscreenTypeConvert(item.param.type).icon,
              title: this.$t(displayscreenTypeConvert(item.param.type).title)
            },
            {
              id: 2,
              icon: equiStatusConvert(item.param.status).icon,
              title: this.$t(equiStatusConvert(item.param.status).title)
            },
            {
              id: 3,
              icon: 'iconfont icon-guanbibaojing',
              title: $t('device.alarm_on')
            }
          ].concat(array))
        }
        case '3': {
          return (this.iconDetaiArray = [
            {
              id: 1,
              icon: relayTypeConvert(item.param.type).icon,
              title: this.$t(relayTypeConvert(item.param.type).title)
            }
          ].concat(array))
        }
        default:
          break
      }
    },
    handleClick (item) {
      switch (item.id) {
        case 1: {
          this.handleWin(item)
          break
        }
        case 2: {
          this.handleRefresh(item)
          break
        }
        case 3: {
          this.handleSave(item)
          sessionStorage.setItem('newArray', JSON.stringify(this.newArray))
          break
        }
        default:
          break
      }
    },
    handleWin (item) {
      goNewWindows({
        path: '/datadevice',
        way: '_blank',
        query: {
          isShowClose: true
        }
      })
    },
    // 保存按钮
    handleSave (item) {
      const queryArray = this.newArray.map(item => ({
        deviceCatalog: item.deviceCatalog,
        deviceId: item.param.id
      }))
      monitorAdd(queryArray).then(({ result, state }) => {
        if (result && state.code === 200) {
          this.$message.success($t('integration.saved_successfully'))
        } else {
          this.$message.error(state.msg)
        }
      })
    },
    getSessionValue () {
      return sessionStorage.getItem('newArray')
    },
    // 刷新
    handleRefresh () {
      return new Promise(resolve => {
        this.$emit('handleRefresh')
        resolve()
      })
    },
    // 网关详细
    handleGateway (item) {
      console.log(item)
      bus.$emit('gatewayParam', item.param.gatewayId, item.param.gatewayName)
    }
  }
}
</script>

<style lang="scss" scoped>
.rightContent {
  flex: 1;
  margin-left: 15px;

  .header {
    height: 29px;
    border-bottom: 1px solid #cccccc;
    margin-bottom: 15px;

    display: flex;
    justify-content: space-between;

    h1 {
      font-size: 16px;
    }

    i {
      cursor: pointer;
      margin-right: 5px;

      // &:hover {
      //   color: red;
      //   font-weight: bold;
      // }
    }
  }

  .rightMsg {
    width: 100%;
    height: calc(100% - 30px);
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;

    overflow: auto;
  }
}
</style>
